import { render, staticRenderFns } from "./AttachmentButton.vue?vue&type=template&id=910f2478&scoped=true"
import script from "./AttachmentButton.vue?vue&type=script&lang=js"
export * from "./AttachmentButton.vue?vue&type=script&lang=js"
import style0 from "./AttachmentButton.vue?vue&type=style&index=0&id=910f2478&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "910f2478",
  null
  
)

export default component.exports